export default __webpack_public_path__ + "static/media/big_scoop.848e6b22.glb";